import frontimage from "../assets/bskro.jpg";
import React from "react";
import styled from "styled-components";
import image from "../assets/BGlightgrey.png";
import contectfm from "../assets/Contact form.png";
import imagewht from "../assets/BG_white.png";
import gifimage from "../assets/Contact us.gif";
import Fontimg from "../assets/get a quote.png";
import gifimage1 from "../assets/Canada.gif";
import gifimage2 from "../assets/Pakistan.gif";
import ourvisit from "../assets/or visit us at our.png";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
`;

const BannerImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const Contanier1 = styled.div`
  width: 100%;
  height: 550px;
  background-image: url(${image});
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
  position: relative;

  @media (max-width: 1024px) {
    height: auto;
    padding-top: 50px;
    flex-direction: column;
    align-items: center;
    margin-bottom: 60px;
    justify-content: center;
  }

  @media (max-width: 768px) {
    height: auto;
    margin-bottom: 60px;
    padding-top: 50px;
  }
  @media (max-width: 576px) {
    height: auto;
    padding-top: 50px;
  }
  @media (max-width: 430px) {
    height: auto;
    padding-top: 50px;
    margin-bottom: 45px;
  }
`;

const Contanier2 = styled(Contanier1)`
  flex-direction: column;
  justify-content: space-around;
  background-image: url(${imagewht});
`;

const FormImage = styled.img`
  width: 65%;
  height: auto;
  margin-bottom: 20px;
  position: relative;
  top: 90px;
  z-index: 1;

  @media (max-width: 2200px) {
    width: 55%;
  }

  @media (max-width: 1700px) {
    width: 65%;
  }

  @media (max-width: 1024px) {
    width: 90%;
    height: 800px;
    margin-bottom: 0;
    position: absolute;
    top: 0;
    z-index: 1;
    margin-top: 60px;
    left: 50%;
    transform: translateX(-50%);
    /* top: 0; */
    /* z-index: 1; */
    top: 70px;
  }

  @media (max-width: 768px) {
    width: 90%;
    height: 800px;
    margin-bottom: 0;
    position: absolute;
    /* top: 0; */
    z-index: 1;
    padding-top: 20px;

    top: 70px;
  }

  @media (max-width: 576px) {
    width: 90%;
    height: 700px;
    margin-bottom: 0;
    position: absolute;
    /* top: 0; */
    z-index: 1;
    padding-top: 20px;
    top: 45px;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (max-width: 430px) {
    width: 90%;
    height: 650px;
    margin-bottom: 0;
    position: absolute;
    /* top: 0; */
    z-index: 1;
    padding-top: 20px;
    top: 55px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const FontImage = styled.img`
  width: 25%;
  height: auto;
  margin-top: 30px;
  position: relative;
  top: 30px;
  left: 13%; /* Changed from 0% to 50% */
  transform: translateX(-50%);
  z-index: 5;
  padding-top: 20px;

  @media (max-width: 1024px) {
    width: 40%;
    height: auto;
    margin-top: 20px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5;
    padding-top: 20px;
    /* top: 0; */
  }

  @media (max-width: 768px) {
    width: 60%;
    position: absolute;
    top: 0;
    padding-top: 20px;
    left: 50%;
    transform: translateX(-50%);

    z-index: 5;
  }
`;

const FormContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 60%;
  padding: 20px;
  height: auto;
  /* background-color: #ec1212; */
  position: absolute;
  margin-bottom: 50px;
  bottom: -70px;
  z-index: 1;
  flex-wrap: wrap;

  @media (max-width: 2200px) {
    width: 50%;
    height: auto;
  }

  @media (max-width: 1700px) {
    width: 60%;
    height: auto;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    width: 90%;
    position: static;
    padding-top: 180px;
    margin-bottom: 0px;
    padding-bottom: 0%;
    align-items: center;
    gap: 20px;
    bottom: 0px;
    z-index: 1;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    width: 90%;
    position: static;
    padding-top: 180px;
    margin-bottom: 0px;
    padding-bottom: 0%;
    align-items: center;
    gap: 20px;
    bottom: 0px;
    z-index: 1;
  }
  @media (max-width: 576px) {
    flex-direction: column;
    width: 90%;
    position: static;
    padding-top: 150px;
    margin-bottom: 0px;
    padding-bottom: 0%;
    align-items: center;
    gap: 20px;
    bottom: 0px;
    z-index: 1;
  }
  @media (max-width: 430px) {
    flex-direction: column;
    width: 90%;
    position: static;
    padding-top: 130px;
    margin-bottom: 0px;
    padding-bottom: 0%;
    align-items: center;
    gap: 20px;
    bottom: 0px;
    z-index: 1;
  }
`;

const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 35px;
  width: 100%;
  max-width: 45%;

  @media (max-width: 1024px) {
    max-width: 100%;
  }
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 45%;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const InputField = styled.input`
  width: 100%;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  font-size: 18px;

  @media (max-width: 992px) {
    width: 100%;
  }
  @media (max-width: 576px) {
    font-size: 16px;
    padding: 15px;
  }
  @media (max-width: 480px) {
    font-size: 14px;
    padding: 10px;
  }
  @media (max-width: 320px) {
    font-size: 12px;
    padding: 8px;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 200px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  font-size: 16px;
  resize: none;

  @media (max-width: 1024px) {
    margin-top: 50px;
  }
  @media (max-width: 786px) {
    margin-top: 50px;
  }
`;

const SelectField = styled.select`
  width: 100%;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  font-size: 18px;

  @media (max-width: 992px) {
    width: 100%;
  }
  @media (max-width: 576px) {
    font-size: 16px;
    padding: 15px;
  }
  @media (max-width: 480px) {
    font-size: 14px;
    padding: 10px;
  }
  @media (max-width: 320px) {
    font-size: 12px;
    padding: 8px;
  }
`;

const SendButton = styled.button`
  padding: 10px 20px;
  font-size: 25px;
  color: #000;
  background-color: #fff;
  border: none;
  border-radius: 5px;
  font-family: calistoga;
  font-weight: bold;
  cursor: pointer;
  width: 250px;
  align-self: center;

  &:hover {
    background-color: #165ba5;
    color: white;
  }

  @media (max-width: 576px) {
    font-size: 16px;
    padding: 8px 16px;
  }
`;

const ContectGifContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: -170px;
  width: 30%;
  height: 30%;
  top: 300px;

  @media (max-width: 1024px) {
    position: static;
    width: 30%;
    margin-top: 20px;
    justify-content: center;
  }
  @media (max-width: 768px) {
    position: static;
    width: 40%;
    margin-bottom: 20px;
    justify-content: center;
  }
  @media (max-width: 576px) {
    position: static;
    width: 40%;
    margin-bottom: 20px;
    /* margin-top: 20px; */
    justify-content: center;
  }
  @media (max-width: 430px) {
    /* position: static; */
    width: 70%;
    /* border-color: red; */
    top: 160px;
    right: -190px;
    margin-top: 0px;
    /* margin-bottom: 20px; */

    justify-content: center;
  }
  @media (max-width: 320px) {
    position: static;
    width: 100%;
    margin-top: 20px;
    justify-content: center;
  }
`;

const ContectGif = styled.img`
  width: 70%;
  height: auto;
  /* background-color: blue; */
  @media (max-width: 1200px) {
    width: 100%;
    height: auto;
    display: none;
  }
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    display: none;
  }
  @media (max-width: 576px) {
    width: 100%;
    height: auto;
    display: none;
  }
  @media (max-width: 430px) {
    width: 40%;
    display: none;
    height: auto;
  }
  @media (max-width: 320px) {
    width: 100%;
    height: auto;
  }
`;

const CardContainer = styled.div`
  display: flex;
  align-items: center;
  /* padding: 20px; */
  /* background-color: #ec1212; */
  border-radius: 10px;
  width: 42%;

  @media (max-width: 1024px) {
   
    width: 90%;
   
  }

  @media (max-width: 768px) {
    display: flex;
    width: 95%;
   
  }
`;

const CardImage = styled.img`
  width: 20%;
  height: auto;
  margin-right: 20px;
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  /* background-color: blue; */
`;

const CardTitle = styled.h3`
  font-size: 35px;
  margin: 0 0 10px;
  font-family: calistoga;
  color: #11c9f7;
  @media (max-width: 768px) {
    font-size: 25px;
  }
  @media (max-width: 576px) {
    font-size: 29px;
  }
  @media (max-width: 480px) {
    font-size: 27px;
  }
`;

const CardDescription = styled.p`
  font-size: 24px;
  margin: 0;
  @media (max-width: 768px) {
    font-size: 18px;
  }
  @media (max-width: 576px) {
    font-size: 17px;
  }
  @media (max-width: 480px) {
    font-size: 16px;
  }
  @media (max-width: 320px) {
    font-size: 12px;
  }
`;

const OurvisitDiv = styled.img`
  width: 40%;
  height: auto;
  margin-top: 180px;
  align-self: center;

  @media (max-width: 1024px) {
    width: 65%;
    margin-top: 40px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (max-width: 768px) {
    width: 65%;
    margin-top: 40px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  @media (max-width: 576px) {
    width: 80%;
    margin-top: 20px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  @media (max-width: 430px) {
    width: 68%;
    padding-top: 0px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const MainCont = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 20px;
  width: 100%;
  /* background-color: green; */
  height: 50%;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    padding: 40px;
    margin-top: 60px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    padding: 40px;
    gap: 40px;
    margin-top: 20px;
  }
`;

const AboutUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,     // Animation duration
      once: false,        // Her baar animate karein jab visible ho
      mirror: true,       // Scroll up par bhi animate ho
      easing: 'ease-in-out',
      anchorPlacement: 'top-bottom', // Kab animate ho (jab top of element bottom of viewport ko touch kare)
      delay: 100
    });

  }, []);
  return (

    <Wrap>
      <BannerImage src={frontimage} alt="About Us Banner" />
      <Contanier1>
        <FormImage src={contectfm} alt="Contact Form" />
        <FontImage src={Fontimg} alt="Get a Quote" />
        <FormContainer>
          <LeftContainer>
            <InputField type="text" placeholder="Your Name" />
            <InputField type="email" placeholder="Your Email Address" />
            <SelectField>
              <option value="">Choose the Service</option>
              <option value="mobile-app">Mobile App</option>
              <option value="website">Website</option>
              <option value="mobile-games">Mobile Games</option>
              <option value="other">Other</option>
            </SelectField>
          </LeftContainer>
          <RightContainer>
            <TextArea
              placeholder="Your Message (up to 100 words)"
              maxLength="100"
            />
            <SendButton>Send</SendButton>
          </RightContainer>
          <ContectGifContainer>
            <ContectGif src={gifimage} alt="Contact Animation" />
          </ContectGifContainer>
        </FormContainer>
      </Contanier1>
      <Contanier2>
        <OurvisitDiv src={ourvisit} alt="Visit Us" />
        <MainCont>
          <CardContainer>
            <CardImage data-aos="fade-down"
              data-aos-offset="300"
              data-aos-easing="ease-in-sine" src={gifimage1} alt="Canada Office" />
            <CardContent data-aos="fade-left"
              data-aos-offset="300"
              data-aos-easing="ease-in-sine">
              <CardTitle>Canada Office</CardTitle>
              <CardDescription>
                12 Divinity Circle, Brampton L7A3Y4, Ontario
              </CardDescription>
            </CardContent>
          </CardContainer>
          <CardContainer>
            <CardImage data-aos="fade-down"
              data-aos-offset="300"
              data-aos-easing="ease-in-sine"  src={gifimage2} alt="Pakistan Office" />
            <CardContent data-aos="fade-left"
              data-aos-offset="300"
              data-aos-easing="ease-in-sine">
              <CardTitle>Pakistan Office</CardTitle>
              <CardDescription>
                Suite # 11, Ground Floor, 69-B-2 AI- Hafeez suites, Gulberg 3,
                Lahore.
              </CardDescription>
            </CardContent>
          </CardContainer>
        </MainCont>
      </Contanier2>
    </Wrap>
  );
};

export default AboutUs;
